import React from "react";
import { Navigate } from "react-router-dom";
import AdminAlertsPage from "./admin";
import { getUserInfo } from "../../helpers/user";

const RiskmapPageRouteWrapper = () => {
    const userInfo = getUserInfo();

    if (userInfo.role === "admin") {
        return <AdminAlertsPage />;
    } else if (userInfo.role === "user" || userInfo.role === "org_admin") {
        return <Navigate to="/" />;
    } else {
        return <Navigate to="/login" />;
    }
};

export default RiskmapPageRouteWrapper;
